<template>
  <table class="table table-responsive mb-2">
    <thead class="bg-grey">
      <tr>
        <th scope="col" style="width: 40%;" class="pl-3">Índice de Risco</th>
        <th scope="col" style="width: 40%;">Conclusão</th>
        <th scope="col" style="width: 10%;">Cor</th>
      </tr>
    </thead>
    <tbody>
    <!-- Low risk line -->
      <tr >
      <!-- Low risk index -->
        <td>
          <d-form-row class="row-container">
            <span>valor &lt;</span>
            <d-form-input
              type="text"
              v-model="model.lowRisk"
              placeholder="Índice de risco baixo"
            />
          </d-form-row>
        </td>
        <!-- Low risk conclusion -->
        <td>
          <d-form-input
            type="text"
            class="text-input"
            v-model="model.lowRiskConclusion"
            placeholder="Conclusão para índice de risco baixo"
          />
        </td>
        <!-- Low risk color -->
        <td>
          <d-input
            type="color"
            class="feColor riskColor"
            placeholder="Baixo risco"
            v-model="model.lowRiskColor"
          />
        </td>
      </tr>
      <!-- Medium risk line -->
      <tr>
        <!-- Medium risk index -->
        <td>
          <d-form-row class="row-container">
            <span>valor &gt;=</span>
            <d-form-input
              style="width: 29%; min-width: 48px;"
              type="text"
              v-model="model.mediumRisk1"
              placeholder="Índice médio"
            />
            <div>
              <span>e valor &lt;=</span>
              <d-form-input
                style="width: 64%; min-width: 45px;"
                type="text"
                v-model="model.mediumRisk2"
                placeholder="Índice médio"
              />
            </div>
          </d-form-row>
        </td>
        <!-- Medium risk conclusion -->
        <td>
          <d-form-input
            type="text"
            class="text-input"
            v-model="model.mediumRiskConclusion"
            placeholder="Conclusão para índice de risco médio"
          />
        </td>
        <!-- Medium risk color -->
        <td>
          <d-input
            type="color"
            class="feColor riskColor"
            placeholder="Médio risco"
            v-model="model.mediumRiskColor"
          />
        </td>
      </tr>
      <!-- High risk line -->
      <tr>
        <!-- High risk index -->
        <td>
          <d-form-row class="row-container">
            <span>valor &gt;</span>
            <d-form-input
              type="text"
              v-model="model.highRisk"
              placeholder="Índice de risco alto"
            />
          </d-form-row>
        </td>
        <!-- High risk conclusion -->
        <td>
          <d-form-input
            type="text"
            class="text-input"
            v-model="model.highRiskConclusion"
            placeholder="Conclusão para índice de risco alto"
          />
        </td>
        <!-- High risk color -->
        <td>
          <d-input
            type="color"
            class="feColor riskColor"
            placeholder="Alto risco"
            v-model="model.highRiskColor"
          />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import Events from '_utils/events';
import { _LOAD_MODEL_RESULTS_ } from '../SettingsModel';

export default {
  name: 'chemical-result-table',
  data() {
    return {
      model: { ...this.chemical },
    };
  },
  props: {
    chemical: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_RESULTS_, newValue => {
      this.model = { ...newValue.chemical };
    });
  },
  watch: {
    model: {
      handler(newValue) {
        this.$emit('update:chemical', newValue);
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
table {
  color: #5A6169;
}

th {
  color: #424242;
}

td {
  vertical-align: middle;
}

.row-container input {
  width: 30%;
  min-width: 48px;
}

.row-container div {
  display: flex;
  align-items: center;
  gap: inherit;
}

.row-container div span {
  white-space: nowrap;
}

.text-input {
  width: 80%;
}

.feColor.riskColor {
  height: 37px;
  min-width: 43px;
}

@media (max-width: 600px) {
  .row-container {
    flex-wrap: wrap;
  }

  td, th {
    padding-left: 4px;
  }

  th {
    padding-right: 0;
  }
}
</style>
